import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseApi } from './base-api.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuthService {

  applicant: any;
  applicantID: string;

  private baseUrl = '/users';

  constructor(
    private api: BaseApi,
    private snackbar: MatSnackBar
  ) { }

  logout() {
    this.applicant = null;
    sessionStorage.removeItem('wl-applicant-id');
    sessionStorage.removeItem('wl-custId');
    sessionStorage.removeItem('wzbvdsjvbbs');
    // sessionStorage.clear();
  }

  loggedIn() {
    return sessionStorage.getItem('wl-applicant-id') ? true : false;
  }

  registerUser(user) {
    return this.api.newPost(`${this.baseUrl}/register`, user).pipe(map(user => 'Registration Successful'));
  }

  sendOTP(mobileNo) {
    return this.api.newPost(`${this.baseUrl}/otp`, { mobileNo: mobileNo })
      .pipe(catchError(err => {
        this.snackbar.open(err.message, 'OK', { duration: 3000 });
        console.error('OTP API Error: ', err);
        return of(err.message);
      }));
  }

  checkPaymentStatus(custId, paymentId) {
    return this.api.postRes(`${this.baseUrl}/getPaymentStatus`, { custId: custId, paymentId: paymentId })
      .pipe(map(res => {
        return res;
      }));
  }

  private storeApplicant(applicant) {
    // sessionStorage.setItem('wl-applicant', JSON.stringify(applicant));
    sessionStorage.setItem('wl-applicant-id', applicant.id);
    sessionStorage.setItem('wl-custId', applicant.custId);
    sessionStorage.setItem('wl-ydl-id', applicant.yodleeUserId);
    this.applicant = applicant;
    this.applicantID = applicant.id;
  }

  getRoleStatus() {
    var role = sessionStorage.getItem('wzbvdsjvbbs');
    if (role == "4dfb05e4-ca35-492b-8a6a-0e0775426090" || role == "6a66230a-ccbf-11ea-87d0-0242ac130003") {
      return true
    } else {
      return false
    }
    // return sessionStorage.getItem('wzbvdsjvbbs');
  }

}
